import $ from "jquery";
import "slick-carousel";

const heroBannerSlick = () => {
  const target = {
    parent: ".hero-banner>.e-con-inner",
  };

  const init = () => {
    $(document).ready(function () {
      if ($(target.parent).length) exec();
    });
  };

  const exec = () => {
    $(target.parent).slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5210,
        speed: 800,
        arrows: false,
        dots: false,
        fade: true,
        // adaptiveHeight: true,
    });
  };

  init();
};

try {
  heroBannerSlick();
} catch (error) {
  throw Error(error);
}
